import React from "react"
import {
  TransitionGroup,
  Transition as ReactTransition,
} from "react-transition-group"

const timeout = 100

const getTransitionStyles = (reversed) => {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768

  let initialTransform = null

  if (!isMobile && typeof reversed !== "undefined") {
    if (reversed) {
      initialTransform = `translateX(-100px)`
    } else {
      initialTransform = `translateX(100px)`
    }
  }

  return {
    entering: {
      position: `absolute`,
      transition: `opacity ${timeout}ms cubic-bezier(0.45, 0, 0.55, 1), transform ${timeout}ms cubic-bezier(0.45, 0, 0.55, 1)`,
      transform: initialTransform,
      opacity: 0,
    },
    entered: {
      transition: `opacity ${timeout}ms cubic-bezier(0.45, 0, 0.55, 1), transform ${timeout}ms cubic-bezier(0.45, 0, 0.55, 1)`,
      opacity: 1,
    },
    exiting: {
      transition: `opacity ${timeout}ms cubic-bezier(0.45, 0, 0.55, 1)`,
      opacity: 0,
    },
    exited: {
      transition: `opacity ${timeout}ms cubic-bezier(0.45, 0, 0.55, 1)`,
      opacity: 0,
    }
  }
}

const Transition = ({ children, location }) => {
  const reversed = location.state?.reverseAnimation

  return (
    <TransitionGroup>
      <ReactTransition
        key={location.pathname}
        timeout={{
          enter: timeout,
          exit: timeout,
        }}
        >
        {status => {
          return (
            <div
              className="min-h-screen px-2 pt-14 md:pt-28 lg:pt-14 md:pr-0 md:pl-0 flex flex-col justify-between"
              style={{ ...getTransitionStyles(reversed)[status] }}
            >
              {children}
            </div>
          )
        }}
      </ReactTransition>
    </TransitionGroup>
  )
}

export default Transition
